<template>
  <div class="news-detail">
    <div class="detail">
      <div class="title">{{ news.title }}</div>
      <div class="info flex-center">
        <div></div>
        <div>{{ getDate(news.publishDate) }}</div>
      </div>
      <div class="row">
        <div class="left">
          <span v-if="news.seq > 0">置顶</span>
          <div class="tag" :style="{ 'margin-left': index > 0 ? '5px' : '0' }" v-for="(item, index) in news.tags"
            :key="index">{{ item }}</div>
        </div>
        <!--        <div class="right">-->
        <!--          <img src="../../assets/share.png" alt="" style="width: 48px; height: 16px;">-->
        <!--        </div>-->
      </div>
      <div class="match" v-if="news.match">
        <img :src="imageView(news.match.icon)" alt="">
        <div>{{ news.match.chineseName }}</div>
      </div>
      <div class="content" ref="content" v-show="news.contentType === 0"></div>
      <video class="content" v-show="news.contentType === 1" :poster="imageView(news.poster, 180, 108)"
        :src="originView(news.video)" width="100%" controls preload></video>
    </div>
  </div>
</template>

<script>
import { getCrmNews } from "@/api/match";
import { QNImageUtil, DateUtil } from "@/utils";
export default {
  data() {
    return {
      id: '',
      news: {}
    }
  },
  mounted() {
    this.id = this.$route.params.newsId
    this.getCrmNews()
    console.log(1);
    
  },
  methods: {
    getDate(date) {
      return DateUtil.parseDateTime(date, '{y}/{m}/{d}')
    },
    getCrmNews() {
      const params = {
        id: this.id
      }
      getCrmNews(params).then(res => {
        if (res) {
          const { data } = res
          this.news = data.news || {}
          if (this.news.account) {
            const account = data.news.account
            // document.title = account.name
            const shareObj = {
              title: this.news.title,
              abstract: account.name,
              image: QNImageUtil.imageView(account.logo)
            }
            this.wxShare(shareObj)
          }
          if (this.news.tags) {
            this.news.tags = this.news.tags === '' ? [] : (this.news.tags.split(',') || [])
          }
          if (this.news.content) {
            this.$refs.content.innerHTML = this.news.content
            // 设置富文本图片样式
            this.$nextTick(() => {
              this.setImageStyles()
            })
          }

        }
      })
    },
    imageView(img, w, h) {
      if (!img) return ''
      return QNImageUtil.imageView(img, w, h)
    },
    originView(video) {
      if (!video) return ''
      return QNImageUtil.originView(video)
    },
    // 设置富文本图片样式
    setImageStyles() {
      const contentElement = this.$refs.content
      if (contentElement) {
        const images = contentElement.querySelectorAll('img')
        images.forEach(img => {
          // 移除可能存在的内联样式
          img.removeAttribute('style')
          // 设置图片样式
          img.style.maxWidth = '100%'
          img.style.height = 'auto'
          img.style.display = 'block'
          img.style.margin = '10px auto'
        })
      }
    }
  }
}
</script>

<style scoped lang="scss">
.news-detail {
  .detail {
    padding: 0 12px;

    .title {
      margin-top: 24px;
      font-size: 18px;
      font-weight: 700;
    }
    .info {
      font-size: 13px;
      color: #73767A;
      margin-top: 20px;
    }

    .row {
      margin-top: 8px;
      display: flex;
      justify-content: space-between;
      align-items: center;

      .left {
        display: flex;
        align-items: center;

        span {
          display: inline-block;
          width: 40px;
          height: 18px;
          line-height: 18px;
          text-align: center;
          background-color: #1649F6;
          color: #FFFFFF;
          font-size: 11px;
          border-radius: 2px;
          margin-right: 5px;
        }

        .tag {
          padding: 3px 8px;
          color: #1565FC;
          background-color: #EBF2FF;
          font-size: 11px;
        }
      }
    }

    .match {
      background-color: #F6F7FA;
      color: #757575;
      font-size: 13px;
      img{
        max-width: 100%;
      }
    }

    .content {
      margin-top: 37px;
      
      // 使用更高优先级的选择器确保富文本图片样式生效
      img {
        max-width: 100% !important;
        height: auto !important;
        display: block;
        margin: 10px auto;
      }
      
      p {
        img {
          max-width: 100% !important;
          height: auto !important;
        }
      }
      
      // 针对可能存在的其他容器
      div img {
        max-width: 100% !important;
        height: auto !important;
      }
    }
  }
}
</style>